import type { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import Footer from '@/components/Footer';

const Container = styled.main`
  color: #fff;
`;

export const LayoutWrapper = styled.section`
  max-width: 1920px;
  margin: 0 auto;
`;

export const ContentWrapper = styled.section`
  max-width: 1580px;
  margin: 0 auto;

  @media (max-width: 1580px) {
    padding: 0 20px;
  }
`;

const StaticLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container>
      {children}
      <Footer></Footer>
    </Container>
  );
};

export default StaticLayout;
